import { EventPlace } from "helpers/analytics";

export function eventPlaceToPrefix(eventPlace: EventPlace): string {
  switch (eventPlace) {
    case EventPlace.Onboarding:
    case EventPlace.InstallCode:
      return "License onboarding";
    case EventPlace.SettingsCustomization:
      return "Customization settings";
    default:
      return eventPlace.toString();
  }
}
